import { render, staticRenderFns } from "./recommend_item_activity.vue?vue&type=template&id=290e372e&scoped=true&"
import script from "./recommend_item_activity.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_activity.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_activity.vue?vue&type=style&index=0&id=290e372e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e372e",
  null
  
)

export default component.exports